import React from "react";
import Icon from '@ant-design/icons';
import { ReactComponent as MaleUser } from 'assets/img/man.svg';
import { ReactComponent as FemaleUser } from 'assets/img/women.svg';
import { ReactComponent as PencilImg } from 'assets/icons/pen.svg';
import { ReactComponent as DeleteImg } from 'assets/icons/delete.svg';
import { ReactComponent as EyeImg } from 'assets/icons/eye-icon.svg';
import { ReactComponent as DashboardImg } from 'assets/icons/dashboard-icon.svg';
import { ReactComponent as DotImg } from 'assets/icons/dot-svgrepo-com.svg';
import { ReactComponent as InterviewImg } from 'assets/icons/personal-icons/inteview.svg';
import { ReactComponent as DocumentsImg } from 'assets/icons/personal-icons/document.svg';
import { ReactComponent as ExamImg } from 'assets/icons/personal-icons/result.svg';
import { ReactComponent as CertificateImg } from 'assets/icons/personal-icons/certificate.svg';
import { ReactComponent as ActiveCandidImg } from 'assets/icons/personal-icons/active-applicant.svg';
import { ReactComponent as PendingCandidImg } from 'assets/icons/personal-icons/pending-applicant.svg';
import { ReactComponent as SendMailImg } from 'assets/icons/send-mail.svg';
import { ReactComponent as DisableSendMailImg } from 'assets/icons/disable-send-mail.svg';
// Define props interface for FemaleIcon component
interface IconProps {
  size: number; // Define size prop as number type
}

const FemaleIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={FemaleUser} style={{ fontSize: size }} />
);
const MaleIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={MaleUser} style={{ fontSize: size }} />
);
const EditIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={PencilImg} style={{ fontSize: size }} />
);
const DeleteIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DeleteImg} style={{ fontSize: size }} />
);
const EyeIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={EyeImg} style={{ fontSize: size }} />
);

const DashboardIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DashboardImg} style={{ fontSize: size }} />
);
const DotIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DotImg} style={{ fontSize: size }} />
);
const InterviewIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={InterviewImg} style={{ fontSize: size }} />
);
const DocumentIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DocumentsImg} style={{ fontSize: size }} />
);
const ResultIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={ExamImg} style={{ fontSize: size }} />
);
const CertificateIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={CertificateImg} style={{ fontSize: size }} />
);
const ActiveCandidateIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={ActiveCandidImg} style={{ fontSize: size }} />
);
const PendingCandidateIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={PendingCandidImg} style={{ fontSize: size }} />
);
const SendMailIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={SendMailImg} style={{ fontSize: size }} />
);
const DisableSendMailIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DisableSendMailImg} style={{ fontSize: size }} />
);
export {
  MaleIcon, FemaleIcon, EditIcon, DeleteIcon, EyeIcon, DashboardIcon, DotIcon, InterviewIcon,
  CertificateIcon, DocumentIcon, ResultIcon, ActiveCandidateIcon, PendingCandidateIcon, SendMailIcon,DisableSendMailIcon
};